/**
 * Util to ensure urls/path segments have a leading slash.
 *
 * Note: `path` may be be an empty string, which will evaluate to falsy,
 * in which case it is returned unchanged, (`getLinkProps` depends on this behavior.)
 */
export const ensureLeadingSlash = (path: string) => {
  return path ? path.replace(/^\/?/, "/") : path;
};
